export const LIMIT = 20;
export const UPLOAD_CONST = "https://nationalngo.net/php/upload.php";
